import type { IconName } from '@zen/Styleguide';

import type { BannerMessageType } from './types';

export const typeWrapperMapping: Record<BannerMessageType, string> = {
  ai: 'border-sunset-base text-grey-dark',
  announcement: 'bg-navy-dark text-white',
  automation: 'border-sunrise-base text-grey-dark',
  default: 'bg-white text-grey-dark border border-solid border-grey-lighter',
  error: 'bg-white text-grey-dark border border-solid border-grey-lighter',
  success: 'bg-white text-grey-dark border border-solid border-grey-lighter',
  warning: 'bg-white text-grey-dark border border-solid border-grey-lighter'
};

export const typeIconColorMapping: Record<BannerMessageType, string> = {
  ai: 'text-sunset-base',
  announcement: 'text-white',
  automation: 'text-sunrise-base',
  default: 'text-grey-light',
  error: 'text-red-dark',
  success: 'text-green-base',
  warning: 'text-orange-base'
};

export const closeIconColorMapping: Record<BannerMessageType, string> = {
  ai: 'text-grey-dark',
  announcement: 'text-white',
  automation: 'text-grey-dark',
  default: 'text-grey-dark',
  error: 'text-grey-dark',
  success: 'text-grey-dark',
  warning: 'text-grey-dark'
};

export const defaultIcon: Record<BannerMessageType, IconName> = {
  ai: 'zicon-sparkles-filled',
  automation: 'zicon-automation-filled',
  announcement: 'zicon-information-filled',
  default: 'zicon-information-filled',
  error: 'zicon-alert-diamond-filled',
  success: 'zicon-tickoval',
  warning: 'zicon-warning-triangle'
};
